export default __webpack_public_path__ + "static/filters-light-mode-71c808827a416515e4da2922f063bbb8.png";